import { render, staticRenderFns } from "./rankItem.vue?vue&type=template&id=5b4ac0c7&scoped=true&"
import script from "./rankItem.vue?vue&type=script&lang=js&"
export * from "./rankItem.vue?vue&type=script&lang=js&"
import style0 from "./rankItem.vue?vue&type=style&index=0&id=5b4ac0c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4ac0c7",
  null
  
)

export default component.exports